import React, { Fragment, useEffect, useState } from "react"
import NavBarUser from "./../../components/shared/NavBarUser"
import { Container } from "react-bootstrap"
import { getVotacionesTricel, cerrarVotacion } from "./../../services/user.service"
import { toast } from "react-toastify"
import ModalConfirmaCierre from "../../components/tricel/ModalConfirmaCierre"
import CardTricel from "../../components/tricel/CardTricel"
import Title from "../../components/shared/Title"
import {aperturaProceso} from "./../../services/admin.service"
import Loader from "../../components/shared/Loader"

const InicioTricel = () => {
	const [votaciones, setVotaciones] = useState([])
	const [showModalCierre, setShowModalCierre] = useState(false)
	const [loaderCierre, setLoaderCierre] = useState(false)
	const [votacionCierre, setVotacionCierre] = useState({})
	const [votacionSelected, setVotacionSelected] = useState({})
	const [loaderApertura, setLoaderApertura] = useState(false)
	const [loader, setLoader] = useState(false)

	const cierraVotacion = async (id) => {
		setLoaderCierre(true)
		const res = await cerrarVotacion(id)
		console.log(res)
		if(res?.response==="success"){
			setShowModalCierre(false)
			getData()
			toast.info('Proceso cerrado correctamente')
		}else{
			toast.warning(res?.message || "No se ha podido cerrar el proceso, verifique con el administrador")
		}
		setLoaderCierre(false)
	}
	
	const confirmaCierre = (votacion) => {
		setVotacionCierre(votacion)
		setShowModalCierre(true)
		console.log(votacion)
	}
	
	const confirmaApertura = async (votacion) => {
		console.log("Aperturando proceso")
		setLoaderApertura(true)
		const res = await aperturaProceso(votacion.id)
		console.log(res)
		if(res?.response === "success"){
			const newArray = votaciones.filter(x=>x.id !== votacion.id)
			setVotaciones([
				...newArray, res.data
			])
		}else{
			toast.error(res?.message || "Se ha producido un error al aperturar votación")
		}

		setLoaderApertura(false)
	}
	
	const getData = async () => {
		setLoader(true)
		const res = await getVotacionesTricel()
		if (res?.response === "success") {
			setVotaciones(res.data)
	
			console.log(res.data)
		} else {
			toast.error(res?.message || "Ha ocurrido un problema al cargar votaciones")
		}
		setLoader(false)
	}

	useEffect(() => {
	
		getData()
	}, [])

	return (
		<Fragment>
			<NavBarUser />
			<Container className="mt-4">
				<Title
					title="Periodos disponibles Tricel"
					descripcion=""
				/>
				{
					loader ?
					<Loader/>
					:
					<CardTricel votaciones={votaciones}
					 confirmaCierre={confirmaCierre}
					 confirmaApertura={confirmaApertura}
					 loaderApertura={loaderApertura}
					 />

				}

			</Container>
			<ModalConfirmaCierre
				show={showModalCierre}
				setShow={setShowModalCierre}
				cierraVotacion={cierraVotacion}
				loader = {loaderCierre}
			 votacion = {votacionCierre}
			/>

		</Fragment>
	)
}

export default InicioTricel
